export type ImportSchemaFieldType =
  | 'string'
  | 'int'
  | 'decimal'
  | 'enum'
  | 'date'
  | 'bool';

export interface ImportSchemaGroup {
  readonly key: string;
  readonly label: string;
}

export interface ImportSchemaEnumValue {
  readonly value: string;
  readonly label: string;
}

export interface ImportSchemaFormat {
  readonly decimalSeparator?: string | null;
  readonly datePattern?: string | null;
}

export interface ImportSchemaField {
  readonly property: string;
  readonly label: string;
  readonly group: string | null;
  readonly type: ImportSchemaFieldType;
  readonly critical: boolean;
  readonly aliases: ReadonlyArray<string>;
  readonly help: string | null;
  readonly format: ImportSchemaFormat | null;
  readonly enumValues: ReadonlyArray<ImportSchemaEnumValue> | null;
}

export interface ImportSchema {
  readonly version: string;
  readonly groups: ReadonlyArray<ImportSchemaGroup>;
  readonly fields: ReadonlyArray<ImportSchemaField>;
}

export const SENTINEL_UNMAPPED = '__unmapped__' as const;

export type CsvHeaderName = string;

export type ColumnMapping = Readonly<Record<string, CsvHeaderName | typeof SENTINEL_UNMAPPED>>;
